/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from 'react';
import { Box, TreeCheck, fetchDataMachine, FETCH_DATA_EVENT, FETCH_DATA_STATE, setSelectOptions, sectionToChinese } from '@oneclass/ui-components';
import { Checkbox, RadioGroup } from '@oneclass/onedesign';
import { Row, Col } from 'antd';
import { useMachine } from '@xstate/react';
import { useSelections } from 'ahooks';
import { LANGUAGE_LIST } from 'constants/index';
import { UiFlexBox } from 'styles/index';
import { format } from 'date-fns';
import { StyledMpAreaSelectContent, UiSelectList } from './MpAreaSelectContent.style';
import { postRangeSelection } from 'api/query';

const nowSchoolYear = format(new Date(), 'yyyy') - 1912;

export const MpAreaSelectContent = ({
  className, resetToggle, examPaperType,
  saveData, getSendAreaParams,
  memberEduSubject,
  getKeyList,
  getTableData,
  getTotalQuesTypeData,
  getSaveData,
  identity,
  renderLoadingContent,
  isLoading,
  setIsLoading,
  isEditCopy,
  isGoBack,
  setIsGoBack,
}) => {
  const [sendParams, setSendParams] = useState({
    ...saveData.areaParams,
    year: (saveData.areaParams.year || (nowSchoolYear)).toString(),
    books: [],
  });
  const [selectLoading, setSelectLoading] = useState(false);
  const [sendYear, setYear] = useState(saveData?.areaParams?.year || (nowSchoolYear) );
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [treeCheckedList, setTreeCheckedList] = useState([]); //["0-0-0"]

  const [stateGetBook, sendGetBook] = useMachine(fetchDataMachine, {
    services: {
      fetchData: async(_context, event) => {
        setSelectLoading(true);
        setIsLoading(true);
        const res = await postRangeSelection(event.payload);
        const { data, isSuccess, systemCode, message } = res;
        const { content } = data;
        setSelectLoading(false);
        if (!isEditCopy) setIsLoading(false);

        if ((JSON.stringify(content) !== '{}')) {
          // 一開始帶入預選
          setSendParams({
            ...sendParams,
            curriculum: '108',
            version: 'N',
            // source: setSelectOptions(sourceTable).map(item => item.value),
          });
          // sourceSetSelected(setSelectOptions(sourceTable).map(item => item.value));
        }

        return {
          isSuccess, systemCode, message,
          bookList: content,
          // sourceOptions: setSelectOptions(sourceTable) || [],
          // volumnTable,
        };
      },
    },
  });

  const {
    bookList = {},
    // sourceOptions,
  } = stateGetBook.context.result || {};

  const sourceOptions = useMemo(() => {
    let options = [];
    if (!treeCheckedList | treeCheckedList.length === 0) return options;
    if (!sendParams.curriculum | !sendParams.year | !sendParams.version | bookList) return options;

    treeCheckedList.forEach((key) => {
      if (typeof key === 'number') return null;
      if (!bookList[sendParams.curriculum][sendParams.year][sendParams.version]) return null;
      Object.values(bookList[sendParams.curriculum][sendParams.year][sendParams.version]).forEach((book) => {
        if (!book?.chapters) return null;
        book.chapters.forEach((chapter) => {
          if (chapter?.Knowledges) {
            // 兩層
            if (!chapter?.Knowledges) return null;
            chapter.Knowledges.forEach((knowledge) => {
              if (knowledge?.code === key) {
                if (!knowledge?.sources) return null;
                knowledge.sources.forEach((source) => {
                  const checkedArray = options.filter((item) => {
                    return item.code === source.code;
                  });
                  if (checkedArray.length === 0) {
                    options.push(source);
                  }
                });
              }
            });
          } else {
            // 三層
            if (!chapter?.data) return null;
            chapter.data.forEach((data) => {
              if (!data?.Knowledges) return null;
              data.Knowledges.forEach((knowledge) => {
                if (knowledge?.code === key) {
                  if (!knowledge?.sources) return null;
                  knowledge.sources.forEach((source) => {
                    const checkedArray = options.filter((item) => {
                      return item.code === source.code;
                    });
                    if (checkedArray.length === 0) {
                      options.push(source);
                    }
                  });
                }
              });
            });
          }
        });
      });
    });

    const sortArray = (array) => {
      return array.sort((a, b) => {
        return a.code.substring(2, 5) - b.code.substring(2, 5);
      }).sort((a, b) => {
        return a.code.substring(0, 2) - b.code.substring(0, 2);
      });
    };

    return setSelectOptions(sortArray(options)) || [];
  }, [treeCheckedList, sendParams.curriculum, sendParams.year, sendParams.version, bookList]);

  useEffect(() => {
    // if (!sourceOptions | sourceOptions.length === 0) return null;
    if (!chapterOptions | !bookOptions | !versionOptions | !yearOptions | !curriculumOptions) return null;
    if (!stateGetBook.matches(FETCH_DATA_STATE.DONE)) return null;
    if (!isGoBack) {
      // 預設全選
      setSendParams({
        ...sendParams,
        source: sourceOptions.map(item => item?.value) || [],
      });
      sourceSetSelected(sourceOptions.map(item => item?.value) || []);
    }
  }, [sourceOptions]);

  const publisherMap = {
    B: '部編',
    CW: '全華',
    G: '綜合',
    H: '翰林',
    K: '康軒',
    KX: '康熹',
    L: '龍騰',
    N: '南一',
    S: '三民',
    T: '泰宇'
  };

  const setRadioOptions = (type, array) => {
    return array.map((item) => {
      if (type === 'curriculum') {
        return {
          label: item + '課綱',
          value: item,
        };
      } else if (type === 'year') {
        return {
          label: item + '學年度',
          value: item,
        };
      } else if (type === 'version') {
        return {
          label: publisherMap[item],
          value: item,
        };
      } else if (type === 'books') {
        return {
          value: item[0],
          name: item[1].volumnName,
        };
      }
    });
  };

  const curriculumOptions = useMemo(() => {
    if (!bookList || JSON.stringify(bookList) === '{}') return [];
    return (memberEduSubject.edu === 'J' || memberEduSubject.edu === 'H') ? setRadioOptions('curriculum', Object.keys(bookList)).filter(item => item.value !== '99') : setRadioOptions('curriculum', Object.keys(bookList));
  }, [bookList]);

  const yearOptions = useMemo(() => {
    if ((!bookList || JSON.stringify(bookList) === '{}') || !sendParams.curriculum) return [];
    return bookList[sendParams.curriculum] ? setRadioOptions('year', Object.keys(bookList[sendParams.curriculum])).filter(item => item.value !== '109') : [];
  }, [sendParams.curriculum, bookList]);

  const versionOptions = useMemo(() => {
    if ((!bookList || JSON.stringify(bookList) === '{}') || !sendParams.curriculum || !sendParams.year) return [];
    return bookList[sendParams.curriculum][sendParams.year] ? setRadioOptions('version', Object.keys(bookList[sendParams.curriculum][sendParams.year])) : [];
  }, [sendParams.curriculum, sendParams.year, bookList]);

  const bookOptions = useMemo(() => {
    if ((!bookList || JSON.stringify(bookList) === '{}') || !sendParams.curriculum || !sendParams.year || !sendParams.version) return [];
    return bookList[sendParams.curriculum][sendParams.year][sendParams.version] ? setRadioOptions('books', Object.entries(bookList[sendParams.curriculum][sendParams.year][sendParams.version])) : [];
  }, [sendParams.curriculum, sendParams.year, sendParams.version, bookList]);

  let initIndex = 1000;

  const renderIndex = () => {
    initIndex++;
    return initIndex;
  };

  const chapterOptions = useMemo(() => {
    if ((!bookList || JSON.stringify(bookList) === '{}') || !sendParams.curriculum || !sendParams.year || !sendParams.version || !sendParams.books || !memberEduSubject?.subject) return [];
    const nextData = sendParams.books.map((book) => {
      return {
        title: bookList[sendParams.curriculum][sendParams.year][sendParams.version][book]?.volumnName,
        key: renderIndex(),
        children: bookList[sendParams.curriculum][sendParams.year][sendParams.version][book].chapters.map((chapter) => {
          return {
            title: `第${sectionToChinese(parseInt(chapter.code))}${LANGUAGE_LIST.includes(memberEduSubject?.subject) ? '課' : '章'}_${chapter.name}`,
            key: renderIndex(),
            children: chapter.Knowledges ?
              chapter.Knowledges.map((item) => {
                return {
                  title: item.name,
                  key: item.code
                };
              })
              : chapter.data && chapter.data.map((section) => {
                return {
                  title: `[${section.code}] ${section.name}`,
                  key: renderIndex(),
                  children: section.Knowledges && section.Knowledges.map((item) => {
                    return {
                      title: item.name,
                      key: item.code
                    };
                  })
                };
              })
          };
        }),
      };
    });
    return nextData;
  }, [bookList, sendParams.curriculum, sendParams.year, sendParams.version, sendParams.books, memberEduSubject?.subject]);

  ///////////////////////////////////////////////

  const getAllTreeData = (data) => {
    if (!data || data.length === 0) return [];
    let nextData = [];
    data.forEach(item => {
      let children = [];
      if ('children' in item) {
        children = getAllTreeData(item.children);
        nextData = [...nextData, ...children];
      }
      nextData = [...nextData, item.key];
    });
    return nextData;
  };

  const treeDataLength = useMemo(() => {
    if (!chapterOptions) return 0;
    return getAllTreeData(chapterOptions).length;
  }, [chapterOptions]);

  const onTreeChange = (data) => {
    setTreeCheckedList(data);
    setIsGoBack(false);
  };

  const onCheckAllChange = e => {
    setTreeCheckedList(e.target.checked ? getAllTreeData(chapterOptions) : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  const {
    selected: bookSelected,
    allSelected,
    isSelected,
    toggle,
    toggleAll,
    unSelectAll,
    setSelected,
    partiallySelected,
  } = useSelections(bookOptions.map(item => item.value), saveData.areaParams?.books);

  const {
    selected: sourceSelected,
    allSelected: sourceAllSelected,
    isSelected: sourceIsSelected,
    unSelectAll: sourceUnSelectAll,
    setSelected: sourceSetSelected,
    toggle: sourceToggle,
    toggleAll: sourceToggleAll,
    partiallySelected: sourcePartiallySelected,
  } = useSelections(sourceOptions ? sourceOptions.map(item => item.value) : [], saveData.areaParams?.source || []);

  const onRadioChange = (type, e) => {
    if (type === 'curriculum') {
      const curriculum = e.target.value;
      const year = setRadioOptions('year', Object.keys(bookList[curriculum])).filter(item => item.value !== '109')[0].value;
      // const version = setRadioOptions('version', Object.keys(bookList[curriculum][year]))[0].value;
      setSendParams({
        ...sendParams,
        [type]: curriculum,
        year: year,
        version: 'N',
        books: [],
        source: [],
      });
      setSelected([]);
      setTreeCheckedList([]);
      sourceUnSelectAll();
    } else if (type === 'year') {
      const year = e.target.value;
      // const version = setRadioOptions('version', Object.keys(bookList[sendParams.curriculum][year]))[0].value;
      setSendParams({
        ...sendParams,
        [type]: year,
        version: 'N',
        books: [],
        source: [],
      });
      setSelected([]);
      setTreeCheckedList([]);
      sourceUnSelectAll();
    } else if (type === 'version') {
      setSendParams({
        ...sendParams,
        [type]: e.target.value,
        books: [],
        source: [],
      });
      setSelected([]);
      setTreeCheckedList([]);
      sourceUnSelectAll();
    } else {
      setSendParams({
        ...sendParams,
        [type]: e.target.value
      });
    }
  };

  const onChangeYear = (type, e) => {
    setYear(e.target.value);
  };

  useEffect(() => {
    if (isEditCopy) {
      setIsLoading(true);
    }

    if (!memberEduSubject?.edu || !memberEduSubject?.subject || sendYear === '') return;

    sendGetBook(FETCH_DATA_EVENT.FETCH, {
      payload: {
        edusubject: memberEduSubject?.edu + memberEduSubject?.subject,
        outputStyle: memberEduSubject?.output,
        drawUpStyle: 'CustomPattern',
      }
    });

    setTreeCheckedList([]);
    unSelectAll();
    sourceUnSelectAll();
    if (memberEduSubject?.edu === saveData.education && memberEduSubject?.subject === saveData.subject && sendYear === saveData?.areaParams?.year) return;
    setSendParams({
      curriculum: sendParams.curriculum,
      year: sendYear
    });

    getKeyList([]);
    getTableData({});
    getTotalQuesTypeData({});
  }, [memberEduSubject.edu, memberEduSubject.subject]);

  useEffect(() => {
    if (stateGetBook.matches(FETCH_DATA_STATE.DONE)) {
      if (sendYear === '' || sendYear === saveData?.areaParams?.year) {
        setSendParams(saveData.areaParams);
        setSelected(saveData.areaParams?.books);
        sourceSetSelected(saveData.areaParams?.source);
        setTreeCheckedList(saveData.areaParams?.treeCheckedList || []);
      } // else {
      //   setTreeCheckedList([]);
      //   unSelectAll();
      //   sourceUnSelectAll();
      //   setSelected([]);
      // }
    }
  }, [stateGetBook.value, sendYear]);

  useEffect(() => {
    setSendParams({
      ...sendParams,
      books: bookSelected
    });
  }, [bookSelected]);

  useEffect(() => {
    setSendParams({
      ...sendParams,
      source: sourceSelected
    });
  }, [sourceSelected]);

  useEffect(() => {
    if (treeCheckedList.length === 0) {
      setIndeterminate(false);
      setCheckAll(false);
    } else {
      setIndeterminate(treeCheckedList.length !== treeDataLength ? true : false);
      setCheckAll(treeCheckedList.length !== treeDataLength ? false : true);
    }
  }, [treeDataLength, treeCheckedList]);

  useEffect(() => {
    if (!sendParams) return;
    var inValid = /\s/;
    getSendAreaParams({
      ...sendParams,
      bookIDs: sendParams?.books ? sendParams.books.map(item => `${sendParams.year}${sendParams.version}-${memberEduSubject.edu}${memberEduSubject.subject}${item}`) : [],
      keys: treeCheckedList.filter(item => !inValid.test(item)),
      treeCheckedList
    });
  }, [sendParams, treeCheckedList, memberEduSubject]);

  useEffect(() => {
    if (sendParams.curriculum === saveData.areaParams.curriculum) return;
    if (sendParams.version === saveData.areaParams.version) return;
    if (!sourceOptions) return;
    unSelectAll();
    sourceUnSelectAll();
    setSelected([]);
    sourceSetSelected(sourceOptions.map(item => item.value));
  }, [sendParams.curriculum, sendParams.version]);

  useEffect(() => {
    const nextData = treeCheckedList.filter(item => getAllTreeData(chapterOptions).includes(item));
    setTreeCheckedList(nextData);
  }, [sendParams.books]);

  useEffect(() => {
    getSaveData('bookOptions', bookOptions);
  }, [bookOptions]);

  const mounted = React.useRef(false);
  useEffect(() => {
    if (mounted.current) {
      setSendParams(saveData.areaParams);
      setSelected(saveData.areaParams?.books);
      sourceSetSelected(saveData.areaParams?.source);
      setTreeCheckedList(saveData.areaParams?.treeCheckedList || []);
    } else {
      mounted.current = true;
    }
  }, [resetToggle]);

  return (
    isLoading ?
      renderLoadingContent()
      :
      <StyledMpAreaSelectContent className={className} data-testid="MpAreaSelectContent">
        <UiFlexBox>
          <Box mb={6}>
            <div className="label">課綱</div>
            <UiSelectList>
              <RadioGroup buttonStyle='solid' optionType='button' options={curriculumOptions} value={sendParams?.curriculum} onChange={(e) => {onRadioChange('curriculum', e);}} />
            </UiSelectList>
          </Box>
          <Box mb={6}>
            <div className="label">年度</div>
            <UiSelectList>
              <RadioGroup buttonStyle='solid' optionType='button' options={yearOptions} value={sendParams?.year} onChange={(e) => {onRadioChange('year', e); onChangeYear('year', e);}} />
            </UiSelectList>
          </Box>
          <Box mb={6}>
            <div className='areaBorder'></div>
          </Box>
          {
            !selectLoading &&
            <>
              {
                versionOptions && versionOptions.length > 1 && identity !== 'SchoolTeacher' &&
            <>
              <Box mb={6}>
                <div className="label">版本</div>
                <UiSelectList>
                  <RadioGroup buttonStyle='solid' optionType='button' options={versionOptions} value={sendParams?.version} onChange={(e) => {onRadioChange('version', e);}} />
                </UiSelectList>
              </Box>
              <Box mb={6}>
                <div className='areaBorder'></div>
              </Box>
            </>
              }

              <Box mb={6}>
                <div className="label">
              冊次
                  {
                    sendParams?.curriculum && sendParams?.year &&
                <div >
                  <Checkbox checked={allSelected} onClick={toggleAll} indeterminate={partiallySelected}>全選</Checkbox>
                </div>
                  }


                </div>
                <UiSelectList>
                  {
                    sendParams?.curriculum && sendParams?.year ?
                      bookOptions.map(item => (
                        <>
                          <Row className='checkBoxRow'>
                            <Col><Checkbox checked={isSelected(item.value)} onClick={() => toggle(item.value)} >{item.name}</Checkbox></Col>
                          </Row>
                        </>

                      )) :
                      <div className="stepHint">
                  請先選擇課綱與年度。
                      </div>
                  }

                </UiSelectList>
              </Box>

              <Box mb={6}>
                <div className='areaBorder'></div>
              </Box>

              <Box mb={6}>
                <div className="label">
                章節
                  {
                    sendParams?.books && sendParams?.books.length > 0 && chapterOptions.length > 0 &&
                  <div>
                    <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>全選</Checkbox>
                  </div>
                  }

                </div>
                <UiSelectList>
                  {
                    sendParams?.books && sendParams?.books.length > 0 && chapterOptions.length > 0 ?
                      <TreeCheck treeData={chapterOptions} checkedList={treeCheckedList} onChange={onTreeChange} /> :
                      <div className="stepHint">
                  請先選擇冊次。
                      </div>
                  }

                </UiSelectList>
              </Box>

              <Box mb={6}>
                <div className='areaBorder'></div>
              </Box>

              <Box mb={6}>
                <div className="label">
              出處
                  {
                    sourceOptions && treeCheckedList && treeCheckedList.length > 0 &&
                <div >
                  <Checkbox checked={sourceAllSelected} onClick={sourceToggleAll} indeterminate={sourcePartiallySelected}>全選</Checkbox>
                </div>
                  }


                </div>
                <UiSelectList>
                  {
                    sourceOptions && treeCheckedList && treeCheckedList.length > 0 ?
                      sourceOptions && sourceOptions.map(item => (
                        <>
                          <Row className='checkBoxRow'>
                            <Col><Checkbox checked={sourceIsSelected(item.value)} onClick={() => sourceToggle(item.value)} >{item.name}</Checkbox></Col>
                          </Row>
                        </>

                      )) :
                      <div className="stepHint">
                  請先選擇章節。
                      </div>
                  }
                </UiSelectList>
              </Box>
            </>
          }

        </UiFlexBox>
      </StyledMpAreaSelectContent>
  );
};